import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { loginRequest, logoutRequest, verifyRequest, getSessionToken, getStoredUser } from '../api/auth';

export const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getStoredUser());

  const login = useCallback(async (username, password) => {
    const result = await loginRequest(username, password);
    if (result.success) setUser(result.user);
    return result;
  }, []);

  const logout = useCallback(async () => {
    await logoutRequest();
    setUser(null);
  }, []);

  const verifyToken = useCallback(async () => {
    const result = await verifyRequest();
    setUser(result.isValid ? result.user : null);
    return result;
  }, []);

  const isAuthenticated = useCallback(() => !!getSessionToken(), []);

  const value = useMemo(
    () => ({ user, login, logout, verifyToken, isAuthenticated }),
    [user, login, logout, verifyToken, isAuthenticated]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
